// extracted by mini-css-extract-plugin
export default {"container":"gE-z","dimension":"hE-z","dimensionLabels":"iE-z"};